import {Accordion} from "@pg-design/accordion-module";
import {Text} from "@pg-design/text-module";

import type {IFaqQuestion} from "../types/IFaqQuestion";

import * as styles from "./FaqQuestion.module.css";

interface IProps extends IFaqQuestion {}

export const FaqQuestion = (props: IProps) => {
    return (
        <Accordion>
            <Accordion.Header>
                <Text as="h2" variant="headline_6">
                    {props.name}
                </Text>
            </Accordion.Header>
            <Accordion.Content>
                <Text as="div" variant="body_copy_2" className={styles.content}>
                    <div dangerouslySetInnerHTML={{__html: props.answer}}></div>
                </Text>
            </Accordion.Content>
        </Accordion>
    );
};
